import { useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ReadOnlyConversationView } from "~/pages/manifold-nextgen/components/conversations/ReadOnlyConversationView";
import { getSharedConversation } from "~/services/shares";

export const ProjectSharedConversationRoute = () => {
  const { token } = useParams<{ token: string }>();

  if (!token) {
    return null;
  }

  return <ProjectSharedConversation key={token} token={token} />;
};

const ProjectSharedConversation = ({ token }: { token: string }) => {
  const { state } = useLocation();
  const agentDisplayName: string | undefined = state?.agentDisplayName;

  const fetcher = useCallback(
    (signal: AbortSignal) => getSharedConversation(token, { signal }),
    [token]
  );

  const bannerSubtitleContent = agentDisplayName
    ? `Featured session from ${agentDisplayName} · Read-only.`
    : undefined;

  return (
    <ReadOnlyConversationView
      conversationId={null}
      shareToken={token}
      fetcher={fetcher}
      bannerSubtitleContent={bannerSubtitleContent}
      ownerVerb="Shared by"
      notFoundTitle="This featured session isn't available"
      notFoundBody="The link may have been revoked, or it never existed."
      readOnlyFeedback
    />
  );
};
